function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((character) => character.charCodeAt(0)));
}

export function webPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function getPanelPushRegistration() {
  if (!webPushSupported()) throw new Error("Este navegador no soporta Web Push");
  const registration = await navigator.serviceWorker.register("/webpush-sw.js", { scope: "/" });
  if (registration.active) return registration;
  // El primer registro puede volver antes de que el worker esté activo.
  await new Promise((resolve, reject) => {
    const worker = registration.installing || registration.waiting;
    if (!worker) return reject(new Error("No se pudo iniciar el servicio de notificaciones. Recargá e intentá nuevamente."));
    const finish = (error) => {
      clearTimeout(timer);
      worker.removeEventListener("statechange", changed);
      if (error) reject(error); else resolve();
    };
    const changed = () => {
      if (worker.state === "activated") finish();
      else if (worker.state === "redundant") finish(new Error("No se pudo activar el servicio de notificaciones."));
    };
    const timer = setTimeout(() => finish(new Error("El servicio de notificaciones tardó demasiado. Recargá e intentá nuevamente.")), 15000);
    worker.addEventListener("statechange", changed);
    changed();
  });
  return registration;
}

export async function getPanelPushSubscription() {
  if (!webPushSupported()) return null;
  const registration = await getPanelPushRegistration();
  return registration.pushManager.getSubscription();
}

export async function subscribePanelPush(publicKey) {
  if (!webPushSupported()) throw new Error("Este navegador no soporta Web Push");
  if (!publicKey) throw new Error("Falta la clave pública VAPID");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("El permiso de notificaciones no fue concedido");
  }
  const registration = await getPanelPushRegistration();
  const current = await registration.pushManager.getSubscription();
  const expectedKey = urlBase64ToUint8Array(publicKey);
  const currentKey = current?.options?.applicationServerKey;
  if (currentKey) {
    const bytes = new Uint8Array(currentKey);
    if (bytes.length !== expectedKey.length || bytes.some((byte, index) => byte !== expectedKey[index])) {
      throw new Error("Las claves de notificaciones cambiaron. Restablecé los datos de este sitio en el navegador y volvé a conectar tus notificaciones.");
    }
  }
  return (
    current ||
    registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: expectedKey,
    })
  );
}

export async function unsubscribePanelPush() {
  const subscription = await getPanelPushSubscription();
  if (!subscription) return { endpoint: "", removed: false };
  const endpoint = subscription.endpoint;
  const removed = await subscription.unsubscribe();
  return { endpoint, removed };
}
